import { render } from "./FileBrowser.vue?vue&type=template&id=34819478&scoped=true"
import script from "./FileBrowser.vue?vue&type=script&lang=js"
export * from "./FileBrowser.vue?vue&type=script&lang=js"

import "./FileBrowser.vue?vue&type=style&index=0&id=34819478&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34819478"]])

export default __exports__